import { PUSH_NOTIFICATION_TYPES } from "../../../constants/pushNotificationTypes";

/**
 * Convert camelCase type to SEO-friendly kebab-case slug.
 * e.g. cancelReservation -> cancel-reservation
 */
export function typeToSlug(type) {
  if (!type || typeof type !== 'string') return '';
  return type
    .replace(/([A-Z])/g, '-$1')
    .toLowerCase()
    .replace(/^-/, '');
}

const slugToTypeMap = (() => {
  const map = {};
  PUSH_NOTIFICATION_TYPES.forEach((t) => {
    map[typeToSlug(t)] = t;
  });
  return map;
})();

/**
 * Convert camelCase type to human-readable title case for display.
 * e.g. approvedDocument -> Approved Document, cancelReservation -> Cancel Reservation
 */
export function typeToLabel(type) {
  if (!type || typeof type !== 'string') return '';
  return type
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Resolve URL slug back to internal type (camelCase).
 * Supports both kebab-case URL (cancel-reservation) and legacy camelCase (cancelReservation).
 */
export function slugToType(slug) {
  if (!slug || typeof slug !== 'string') return null;
  const normalized = slug.trim();
  if (slugToTypeMap[normalized]) return slugToTypeMap[normalized];
  if (PUSH_NOTIFICATION_TYPES.includes(normalized)) return normalized;
  return null;
}
